export const ADD_CONNECTION = 'ADD_CONNECTION';
export const REMOVE_CONNECTION = 'REMOVE_CONNECTION';
export const REMOVE_CONNECTIONS = 'REMOVE_CONNECTIONS';
export const EDIT_CONNECTION = 'EDIT_CONNECTION';
export const UPDATE_CONNECTION_POINTS = 'UPDATE_CONNECTION_POINTS';
export const SET_CONNECTION_COLOR = 'SET_CONNECTION_COLOR';

export interface ConnectionInterface {
  key: string;
  from: string;
  to: string;
  fromPort: string;
  toPort: string;
  conveyorCalc: boolean;
  connectionInfo?: ConnectionInfoInterface;
  outputFlow?: number;
  flowRatePosition?: number;
  connectionPoints?: ConnectionPointsInterface[];
  color?: string;
}

export interface ConnectionInfoInterface {
  inclination: number;
  elevation: number;
  conveyorSpeed: number;
  throughlingAngle: number;
}

export interface PortKeysInterface {
  from: string;
  to: string;
  fromPort: string;
  toPort: string;
}

export interface ConnectionStateInterface {
  connections: ConnectionInterface[];
}

export interface SimulationRequestConnectionInterface {
  key: string;
  from: string;
  to: string;
  conveyorCalc: boolean;
  connectionInfo?: ConnectionInfoInterface;
  outputFlow?: number;
}

export interface ConnectionPointsInterface {
  x: number;
  y: number;
}
